var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('HomeSwiper'),_c('HomeCar'),_c('HomeTechnology'),_c('HomeStore'),_c('HomeServer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }